import { makeTabTypeFromPlan } from "@/components/newcustomize/utils/makeProxyTabType";
import { PlanType } from "@/types/PlanTypes";

/**
 * Verified plans are no longer sold: the ones still running were kept for the
 * people who had them, and there is no purchase flow to buy one again. A
 * cancelled Verified plan therefore has nothing to offer on the dashboard, so
 * it is left out where other cancelled plans get a "Buy again" (R-2272).
 */
export default function isCancelledVerifiedPlan(plan: PlanType): boolean {
  return (
    plan.status === "cancelled" && makeTabTypeFromPlan(plan) === "verified"
  );
}
